import React from 'react';
import { Button as RSButton } from 'reactstrap';
import { IoRefresh } from 'react-icons/io5';
import { CiExport } from 'react-icons/ci';
import { Dropdown, filterBarSelectStyles } from '@/components/Dropdown';
import { TimezoneDropdown } from '@/components/TimezoneDropdown';
import { SingleDatePicker } from '@/components/SingleDatePicker';
import { Button, buttonVariants } from '@/components/Button';
import { fontWeightEnum, Text, textVariantsEnum } from '@/components/Text';
import styles from './ReportFiltersBar.module.scss';

export const ReportFiltersBarComponent = ({
  membersOptions,
  selectedMember,
  onMemberFilterChange,
  membersLoading,
  membersError,
  membersErrorObj,
  refetchMembers,
  timezoneOptions,
  selectedTimezone,
  onTimezoneChange,
  timezonesLoading,
  date,
  onDateChange,
  onRefresh,
  onExport,
  exportLoading,
  exportDisabled,
  showExport = true,
  dataTour,
}) => {
  return (
    <div className={styles.filtersContainer} data-tour={dataTour}>
      <div className={styles.dropdownsContainer}>
        <div className={styles.dropdown}>
          <Dropdown
            options={membersOptions}
            value={selectedMember}
            placeholder="Select member..."
            onChange={onMemberFilterChange}
            isLoading={membersLoading}
            isDisabled={membersLoading || membersError}
            selectStyles={filterBarSelectStyles}
          />
          {membersError && (
            <div className={styles.memberError}>
              <Text
                variant={textVariantsEnum.Text_sm}
                fontWeight={fontWeightEnum.Medium}
              >
                Failed to load members. {membersErrorObj?.message || ''}
              </Text>
              <RSButton color="link" size="sm" onClick={() => refetchMembers()}>
                Retry
              </RSButton>
            </div>
          )}
        </div>
        <div className={styles.dropdown}>
          <TimezoneDropdown
            placeholder="Select timezone..."
            timezoneOptions={timezoneOptions}
            selectedTimezone={selectedTimezone}
            onChange={onTimezoneChange}
            isLoading={timezonesLoading}
            selectStyles={filterBarSelectStyles}
          />
        </div>
        <SingleDatePicker date={date} onDateChange={onDateChange} compact />
      </div>
      <div className={styles.actionsContainer}>
        <Button
          variant={buttonVariants.outline}
          size="xl"
          text="Refresh"
          icon={<IoRefresh size={16} color="var(--gray-700)" />}
          onClick={onRefresh}
        />
        {showExport && (
          <Button
            variant={buttonVariants.outline}
            size="xl"
            text="Export"
            icon={<CiExport size={16} color="var(--gray-700)" />}
            onClick={onExport}
            loading={exportLoading}
            disabled={exportDisabled}
          />
        )}
      </div>
    </div>
  );
};

ReportFiltersBarComponent.displayName = 'ReportFiltersBar';
